import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "./carousel.css";

import category1Img from "../../assets/img/herbalProduct.webp";
import category2Img from "../../assets/img/yogaProduct.webp";
import spicesImg from "../../assets/img/spicesProduct.webp";
import foodImg from "../../assets/img/foodProduct.jpg";
import gardenImg from "../../assets/img/gardenProduct.webp";

const categoryBannerSlides = [
  {
    id: "cat1",
    title: "Category 1",
    img: category1Img,
    link: "/herbalProduct",
    alt: "Category 1 Products Banner",
  },
  {
    id: "cat2",
    title: "Category 2",
    img: category2Img,
    link: "/yoga",
    alt: "Category 2 Health and Wellness Banner",
  },
  {
    id: "spices",
    title: "Spices",
    img: spicesImg,
    link: "/uniqueProducts",
    alt: "Spices Catalog Banner",
  },
  {
    id: "food",
    title: "Food Products",
    img: foodImg,
    link: "/uniqueProducts",
    alt: "Food Products Banner",
  },
  {
    id: "garden",
    title: "Garden Products",
    img: gardenImg,
    link: "/uniqueProducts",
    alt: "Garden Products Banner",
  },
];

export default function Sliders() {
  const settings = {
    autoplay: true,
    autoplaySpeed: 3500,
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    pauseOnHover: true,
  };

  return (
    <div className="hero-slider-wrapper">
      <Slider {...settings}>
        {categoryBannerSlides.map((slide) => (
          <div key={slide.id} className="carousel-slide-item">
            <Link to={slide.link} className="d-block text-decoration-none">
              <div className="carousel-img-container">
                <img
                  src={slide.img}
                  alt={slide.alt}
                  className="img-fluid carousel-product-img"
                />
              </div>
            </Link>
          </div>
        ))}
      </Slider>
    </div>
  );
}
